import KlaviyoTableReport from './KlaviyoTableReport';

const KlaviyoFlowsReport = (props) => (
    <KlaviyoTableReport {...props} table="klaviyo_flows" />
);

export default KlaviyoFlowsReport;
